import ArkLoader from '@src/js/common/ark-extensions';
import exportAsyncConfig from './component-config';

export interface IExportAsyncOptions {
    docId: string;
    exportType?: number;
    switches?: string;
}

export interface ISuccessResult {
    ret: number;
    msg: string;
    operationId: string;
    [key: string]: any;
}

export interface IErrorResult {
    error: number;
    msg?: string;
    [key: string]: any;
}

export type ISuccessCallback = (result: ISuccessResult) => void;

export type IErrorCallback = (result: IErrorResult) => void;

interface IExportAsyncExtension {
    exportAsync: (
        options: IExportAsyncOptions,
        onSuccess: ISuccessCallback,
        onError: IErrorCallback,
    ) => void;
}

export async function exportAsync(
    options: IExportAsyncOptions,
    success: ISuccessCallback,
    error: IErrorCallback,
): Promise<void> {
    const extension = await ArkLoader.extensionService.getExtension(exportAsyncConfig.name) as IExportAsyncExtension;
    extension.exportAsync(options, success, error);
}

